import {
  type JsonObject,
  type PropertyAttributeType,
  PropertySchemaType,
  zPropertyAttributeType,
} from "~/common/types";
import type { PropertySchemaAssociation_DefaultFragment } from "~/features/admin/propertySchemas/gqls";
import {
  type PropertySchemaAssociationFormData,
  type SelectOption,
  type URLAllowList,
  zSelectOptions,
  zURLAllowList,
} from "~/features/admin/propertySchemas/types";

function toSelectOptions(option: JsonObject): SelectOption[] {
  const ret = zSelectOptions.safeParse(option);
  return ret.success ? ret.data : [];
}

function toURLAllowList(value: JsonObject | null | undefined): URLAllowList {
  if (!value) return [];
  const ret = zURLAllowList.safeParse(value);
  return ret.success ? ret.data : [];
}

function isPropertySchemaType(val: string): val is PropertySchemaType {
  return Object.values(PropertySchemaType).includes(val as PropertySchemaType);
}

export function toAssociationFormData(
  schema: PropertySchemaAssociation_DefaultFragment,
): PropertySchemaAssociationFormData {
  const selectOptions = toSelectOptions(schema.propertySchema.selectOptions);
  const urlAllowList = toURLAllowList(schema.propertySchema.urlAllowList);
  const propertyTypeId = isPropertySchemaType(schema.propertySchema.propertyTypeId)
    ? schema.propertySchema.propertyTypeId
    : PropertySchemaType.String;

  let propertyAttributeTypeId: PropertyAttributeType | undefined;
  if ("propertyAttributeTypeId" in schema) {
    const ret = zPropertyAttributeType.safeParse(schema.propertyAttributeTypeId);
    propertyAttributeTypeId = ret.success ? ret.data : undefined;
  }

  return {
    id: schema.id,
    name: schema.name,
    description: schema.description ?? undefined,
    position: schema.position ?? 0,
    required: schema.required,
    unique: schema.unique,
    propertyAttributeTypeId,
    propertySchema: {
      id: schema.propertySchema.id,
      propertyTypeId,
      selectOptions,
      urlAllowList,
    },
  };
}
